import {
  Group,
  Switch,
  Text,
  Select,
  Checkbox,
  Stack,
  Paper,
  Title,
  Divider,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import MultiRemoteSelect from "./multiRemoteSelect";
import RemoteSelect2 from "./remoteSelect2";

const LevySettings = ({ form }) => {
  const { t } = useTranslation();

  const levySettings = form.values.levySettings || {
    iaLevy: {
      required: true,
      exceptInsurers: [],
    },
    ecLevy: {
      required: false,
      exceptInsurers: [],
      formulaType: "full",
    },
    mibLevy: {
      required: false,
      exceptInsurers: [],
      formulaType: "direct",
    },
  };

  const handleLevyChange = (levyType, field, value) => {
    const currentSettings = form.values.levySettings || {};
    const currentLevy = currentSettings[levyType] || {};

    form.setFieldValue(`levySettings.${levyType}.${field}`, value);
  };

  const handleExceptInsurersChange = (levyType, value) => {
    form.setFieldValue(`levySettings.${levyType}.exceptInsurers`, value);
  };

  return (
    <Stack spacing="md">
      {/* IA Levy Section */}
      <Paper p="md" withBorder>
        <Title order={6} mb="sm">
          IA Levy
        </Title>
        <Stack spacing="sm">
          <Switch
            label="Required"
            checked={levySettings.iaLevy?.required || false}
            onChange={(event) =>
              handleLevyChange(
                "iaLevy",
                "required",
                event.currentTarget.checked
              )
            }
            size="sm"
          />
          {levySettings.iaLevy?.required && (
            <RemoteSelect2
              form={form}
              name="levySettings.iaLevy.exceptInsurers"
              label="Except Insurers"
              apiEntity="provider"
              valueField="_id"
              labelField="name"
              multiple={true}
              labelRender={(data) => `[${data.code}] ${data.name}`}
              searchFields={["name", "code", "shortName"]}
              placeholder="Select insurers to exclude"
              pageSize={100}
              sort={{ by: "name", order: "asc" }}
            />
          )}
        </Stack>
      </Paper>

      {/* EC Levy Section */}
      <Paper p="md" withBorder>
        <Title order={6} mb="sm">
          EC Levy
        </Title>
        <Stack spacing="sm">
          <Switch
            label="Required"
            checked={levySettings.ecLevy?.required || false}
            onChange={(event) =>
              handleLevyChange(
                "ecLevy",
                "required",
                event.currentTarget.checked
              )
            }
            size="sm"
          />
          {levySettings.ecLevy?.required && (
            <>
              <Select
                label="Formula Type"
                value={levySettings.ecLevy?.formulaType || "full"}
                onChange={(value) =>
                  handleLevyChange("ecLevy", "formulaType", value)
                }
                data={[
                  { value: "full", label: "Full (10.8% for Direct EC)" },
                  {
                    value: "parial",
                    label: "Partial (only partial on Gross Premium)",
                  },
                ]}
                size="sm"
              />
              <RemoteSelect2
                form={form}
                name="levySettings.ecLevy.exceptInsurers"
                label="Except Insurers"
                apiEntity="provider"
                valueField="_id"
                labelField="name"
                multiple={true}
                labelRender={(data) => `[${data.code}] ${data.name}`}
                searchFields={["name", "code", "shortName"]}
                placeholder="Select insurers to exclude"
                pageSize={100}
                sort={{ by: "name", order: "asc" }}
              />
            </>
          )}
        </Stack>
      </Paper>

      {/* MIB Levy Section */}
      <Paper p="md" withBorder>
        <Title order={6} mb="sm">
          MIB Levy
        </Title>
        <Stack spacing="sm">
          <Switch
            label="Required"
            checked={levySettings.mibLevy?.required || false}
            onChange={(event) =>
              handleLevyChange(
                "mibLevy",
                "required",
                event.currentTarget.checked
              )
            }
            size="sm"
          />
          {levySettings.mibLevy?.required && (
            <>
              <RemoteSelect2
                form={form}
                name="levySettings.mibLevy.exceptInsurers"
                label="Except Insurers"
                apiEntity="provider"
                valueField="_id"
                labelField="name"
                multiple={true}
                labelRender={(data) => `[${data.code}] ${data.name}`}
                searchFields={["name", "code", "shortName"]}
                placeholder="Select insurers to exclude"
                pageSize={100}
                sort={{ by: "name", order: "asc" }}
              />
            </>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
};

export default LevySettings;
